import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDistributionLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 159,
	height: 24,
	viewBox: "0 0 159 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "ÐÑÐ³Ð°Ð½ÑÐ·Ð°ÑÑÑ",
		children: /* @__PURE__ */ _jsx("g", {
			id: "ÐÑÐ³Ð°Ð½ÑÐ·Ð°ÑÑÑ | Ð¡Ð¿ÑÐ²ÑÐ¾Ð±ÑÑÐ½Ð¸ÐºÐ¸",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Frame 1948755679",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Frame 1948754564",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Frame 1948754560",
						children: /* @__PURE__ */ _jsx("g", {
							id: "<Autocomplete>",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Frame 1948755840",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Frame 1948755836",
									children: /* @__PURE__ */ _jsxs("g", {
										id: "Logo_all",
										children: [/* @__PURE__ */ _jsxs("g", {
											id: "distribution",
											children: [
												/* @__PURE__ */ _jsx("path", {
													id: "Vector",
													d: "M154.413 8.13306C157.11 8.13306 158.719 9.89481 158.719 12.8093V20.3566H156.262V13.3096C156.262 11.4608 155.457 10.4821 153.652 10.4821C151.542 10.4821 150.411 11.8523 150.411 14.1578V20.3566H147.953V8.39406H150.411V10.3733C151.259 8.98131 152.542 8.13306 154.413 8.13306Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Vector_2",
													d: "M139.296 8.13306C142.733 8.13306 145.495 10.7648 145.495 14.3753C145.495 17.9641 142.776 20.6176 139.296 20.6176C135.838 20.6176 133.098 17.9423 133.098 14.3753C133.098 10.7648 135.882 8.13306 139.296 8.13306ZM139.296 10.4821C137.23 10.4821 135.577 12.0698 135.577 14.3753C135.577 16.6808 137.208 18.2686 139.296 18.2686C141.384 18.2686 143.016 16.6808 143.016 14.3753C143.016 12.0698 141.363 10.4821 139.296 10.4821Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Vector_3",
													d: "M129.396 3C130.332 3 131.006 3.63075 131.006 4.50075C131.006 5.3925 130.332 6.045 129.396 6.045C128.505 6.045 127.809 5.3925 127.809 4.50075C127.809 3.63075 128.505 3 129.396 3ZM128.178 20.3565V8.394H130.636V20.3565H128.178Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Vector_4",
													d: "M125.492 17.7466L125.927 19.7476C125.274 20.1391 123.882 20.6176 122.512 20.6176C120.054 20.6176 118.14 19.0733 118.14 15.7673V10.6996H115.922V8.39409H118.14V5.67534L120.598 5.13159V8.39409H125.514V10.6996H120.598V15.6368C120.598 17.3768 121.403 18.3338 122.947 18.3338C123.708 18.3338 124.557 18.0728 125.492 17.7466Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Vector_5",
													d: "M111.546 8.39404H114.003V20.3565H111.546V18.3773C110.697 19.7475 109.414 20.6175 107.565 20.6175C104.912 20.6175 103.324 18.8558 103.324 15.9413V8.39404H105.782V15.441C105.782 17.2898 106.565 18.2685 108.348 18.2685C110.393 18.2685 111.546 16.8983 111.546 14.5928V8.39404Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Vector_6",
													d: "M95.4543 8.13289C98.5863 8.13289 100.957 10.7211 100.957 14.3751C100.957 18.0291 98.6298 20.6174 95.4326 20.6174C93.5621 20.6174 92.1266 19.7039 91.2566 18.3554V20.3564H88.7988V3.60889H91.2566V10.4384C92.1266 9.06814 93.5621 8.13289 95.4543 8.13289ZM94.9106 18.2684C96.9768 18.2684 98.4776 16.6806 98.4776 14.3751C98.4776 12.0914 96.9986 10.4819 94.9106 10.4819C92.8226 10.4819 91.2348 12.0914 91.2348 14.3751C91.2348 16.6806 92.8226 18.2684 94.9106 18.2684Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Vector_7",
													d: "M84.7069 3C85.6421 3 86.3164 3.63075 86.3164 4.50075C86.3164 5.3925 85.6421 6.045 84.7069 6.045C83.8151 6.045 83.1191 5.3925 83.1191 4.50075C83.1191 3.63075 83.8151 3 84.7069 3ZM83.4889 20.3565V8.394H85.9466V20.3565H83.4889Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Vector_8",
													d: "M80.815 8.13306C81.1195 8.13306 81.3587 8.15481 81.5327 8.19831V10.6996C81.3152 10.6778 81.1195 10.6561 80.7932 10.6561C78.5529 10.6561 76.8347 11.9176 76.8347 14.8756V20.3566H74.377V8.39406H76.8347V10.7648C77.5525 9.09006 78.9227 8.13306 80.815 8.13306Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Vector_9",
													d: "M71.6911 17.7466L72.1261 19.7476C71.4736 20.1391 70.0816 20.6176 68.7113 20.6176C66.2536 20.6176 64.3396 19.0733 64.3396 15.7673V10.6996H62.1211V8.39409H64.3396V5.67534L66.7973 5.13159V8.39409H71.7128V10.6996H66.7973V15.6368C66.7973 17.3768 67.6021 18.3338 69.1463 18.3338C69.9076 18.3338 70.7558 18.0728 71.6911 17.7466Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Vector_10",
													d: "M55.6176 20.6176C52.4639 20.6176 50.2019 19.0951 49.7451 16.5068H52.2464C52.6161 17.8336 53.5949 18.4426 55.6611 18.4426C57.2489 18.4426 58.2276 17.9641 58.2276 17.0723C58.2276 16.0718 57.0966 15.9196 55.0956 15.4411C51.7461 14.6146 50.3324 13.9403 50.3324 11.9393C50.3324 9.52506 52.3769 8.13306 55.3784 8.13306C58.4451 8.13306 60.1634 9.59031 60.5984 11.7653H58.1189C57.7709 10.7866 56.8574 10.3081 55.3349 10.3081C53.7471 10.3081 52.8119 10.8518 52.8119 11.6783C52.8119 12.4396 53.5514 12.6353 55.6394 13.1356C58.8801 13.8968 60.7506 14.4623 60.7506 16.7896C60.7506 19.3561 58.4451 20.6176 55.6176 20.6176Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Vector_11",
													d: "M46.2401 3C47.1753 3 47.8496 3.63075 47.8496 4.50075C47.8496 5.3925 47.1753 6.045 46.2401 6.045C45.3483 6.045 44.6523 5.3925 44.6523 4.50075C44.6523 3.63075 45.3483 3 46.2401 3ZM45.0221 20.3565V8.394H47.4798V20.3565H45.0221Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												}),
												/* @__PURE__ */ _jsx("path", {
													id: "Vector_12",
													d: "M39.7223 3.60889H42.18V20.3564H39.7223V18.3554C38.8305 19.7039 37.395 20.6174 35.5245 20.6174C32.3273 20.6174 30 18.0291 30 14.3751C30 10.7211 32.3708 8.13289 35.5028 8.13289C37.395 8.13289 38.8305 9.06814 39.7223 10.4384V3.60889ZM36.0465 18.2684C38.1345 18.2684 39.7223 16.6806 39.7223 14.3751C39.7223 12.0914 38.1345 10.4819 36.0465 10.4819C33.9585 10.4819 32.4795 12.0914 32.4795 14.3751C32.4795 16.6806 33.9803 18.2684 36.0465 18.2684Z",
													fill: "#4D1FF4",
													stroke: "#4D1FF4",
													strokeWidth: .15
												})
											]
										}), /* @__PURE__ */ _jsx("g", {
											id: "Frame 1948755632",
											children: /* @__PURE__ */ _jsxs("g", {
												id: "Group 58",
												children: [
													/* @__PURE__ */ _jsx("path", {
														id: "Rectangle 39",
														d: "M4.37682 14.7873C2.78799 13.4588 2.65561 11.1639 4.08112 9.66148L11.825 1.4999C13.4138 2.82842 13.5462 5.12334 12.1207 6.62575L4.37682 14.7873Z",
														fill: "url(#paint0_linear_3_86)"
													}),
													/* @__PURE__ */ _jsx("path", {
														id: "Rectangle 40",
														d: "M8.15221 18.5564C6.56339 17.2279 6.431 14.9329 7.85651 13.4305L15.6004 5.26894C17.1892 6.59746 17.3216 8.89239 15.8961 10.3948L8.15221 18.5564Z",
														fill: "url(#paint1_linear_3_86)"
													}),
													/* @__PURE__ */ _jsx("path", {
														id: "Rectangle 41",
														d: "M11.8231 22.2053C10.2343 20.8768 10.1019 18.5819 11.5274 17.0795L19.2713 8.91787C20.8601 10.2464 20.9925 12.5413 19.567 14.0437L11.8231 22.2053Z",
														fill: "url(#paint2_linear_3_86)"
													})
												]
											})
										})]
									})
								})
							})
						})
					})
				})
			})
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_3_86",
			x1: 16.0849,
			y1: -.23239,
			x2: 3.49043,
			y2: 14.1636,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .00124008,
				stopColor: "#4B1DF4"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#A19AF8"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_3_86",
			x1: 19.8603,
			y1: 3.53665,
			x2: 7.26582,
			y2: 17.9326,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .00124008,
				stopColor: "#4B1DF4"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#A19AF8"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_3_86",
			x1: 23.5312,
			y1: 7.18558,
			x2: 10.9367,
			y2: 21.5816,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .00124008,
				stopColor: "#4B1DF4"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#A19AF8"
			})]
		})
	] })]
});
export default SvgDistributionLogo;
